// components/ProtectedRoute.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        // Add debug to see what's happening
        console.log('ProtectedRoute - Auth State:', { isAuthenticated, loading });

        if (!loading && !isAuthenticated) {
            console.log('Not authenticated, redirecting to login');
            navigate('/admin/login', { replace: true });
        }
    }, [isAuthenticated, loading, navigate]);

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-900 text-white p-6 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
                    <p>Cargando...</p>
                </div>
            </div>
        );
    }

    // If not authenticated, don't render children (redirect will happen via useEffect)
    if (!isAuthenticated) {
        return null;
    }

    // If authenticated, render children
    return children;
};

export default ProtectedRoute;